import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { SocialMediaPlatform } from '../../models/socialMediaPlatform';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
constructor(
  private spinner: NgxSpinnerService,
  private sanitizer: DomSanitizer,
) { }

getSafeContent(content: string): SafeHtml {
  return this.sanitizer.bypassSecurityTrustHtml(content);
}

whoItWork = [
  {
    image: 'assets/img/whoItWork1.jpg',
    title: '1. Profiling und Stellenanzeige.',
    itmes: [
      "Erstellung präziser Anforderungsprofile.",
      "Gezielte Bewerbung der zu besetzenden Stellen im Ausland. Oder Auswahl geeigneter Kandidaten aus unserem umfangreichen Kandidatenpool.",
      "Kompetente Beratung für Arbeitgeber und Interessenten, z. B. zu Verfahren und Fördermöglichkeiten."
    ]
  },
  {
    image: 'assets/img/whoItWork2.jpg',
    title: '2. Rekrutierung und Matching.',
    itmes: [
      "Individuelle Vorauswahl und Eignungstests.",
      "Vorstellung geeigneter Kandidaten.",
      "Organisation und umfassende Unterstützung im Auswahlprozess.",
      "Vertragsmanagement."
    ]
  },
  {
    image: 'assets/img/whoItWork3.jpg',
    title: '3. Gezielte Vorbereitung für den Einsatz in Ihrem Unternehmen.',
    itmes: [
      "Sprachkurse im Herkunftsland.",
      "Kulturelle und inhaltliche Vorbereitung auf eine Anstellung in Deutschland.",
      "Unterstützung im Anerkennungsverfahren: Begleitung bei Visumanträgen und beruflicher Anerkennung.",
      "Einbindung der Familie im Herkunftsland."
    ]
  },
  {
    image: 'assets/img/whoItWork4.jpg',
    title: '4. Umzugsservice.',
    itmes: [
      "Suche nach Unterkünften und persönliche Begleitung bei der Ankunft.",
      "Administrative Verfahren, Anmeldung und Aufenthaltsangelegenheiten.",
      "Konto, Versicherung und andere organisatorische Angelegenheiten.",
      "Hilfe bei der Orientierung und Vernetzung vor Ort."
    ]
  },
  {
    image: 'assets/img/whoItWork5.jpg',
    title: '5. Integration im Unternehmen.',
    itmes: [
      "Etablierung einer Willkommenskultur in Ihrem Unternehmen.",
      "Checklisten und Workshops für Mitarbeiter und Führungskräfte.",
      "Umfassende Beratung und Unterstützung.",
      "Unsere Marken stehen für diese Einstellungen und Überzeugungen – in jedem unserer Geschäftsbereiche."
    ]
  },
  {
    title: '6. Unser Angebot',
    isSlider: true,
    sliderItems: [
      { image: 'assets/img/departments-1.jpg', pdf: 'assets/pdf/Zusammenarbeit Ausbildung Gesundheit.pdf', label: 'Gesundheitliche Fachkräfte', color: '#0f24e6ff !important', gradientColor: 'rgba(174, 31, 230, 0.8)' },
      { image: 'assets/img/apprentice-learner.jpg', pdf: 'assets/pdf/Zusammenarbeit Medizinische Fachkräfte.pdf', label: 'Ausbildung', color: '#FF6EC7 !important', gradientColor: 'rgba(71, 6, 223, 0.8)' },
      { image: 'assets/img/plumber-chef.jpg', pdf: 'assets/pdf/Zusammenarbeit Presentation Handwerkliche Branche.pdf', label: 'Gastronomische und Handwerkliche Fachkräfte', color: '#17B6E4 !important', gradientColor: 'rgba(204, 35, 35, 0.8)' }
    ]
  }
];

getSubText(text: String) {
  let wordList = text.split(" ");
  if (wordList.length > 15) {
    return wordList.slice(0, 15).join(" ") + " ...";
  } else {
    return text + " ...";
  }
}

handleSuccess(message: string, title: string = 'Erfolg') {
  this.spinner.hide();
  Swal.fire({
    icon: 'success',
    title: title,
    text: message,
    confirmButtonText: 'OK'
  });
}

/**
 * Behandelt Fehlerantworten von Spring Boot
 */
handleError(error: any, title: string = 'Fehler', message?: string) {
  console.log(error);
  this.spinner.hide();
  if (!message) {
    message = this.getError(error);
  }
  Swal.fire({
    icon: 'error',
    title: title,
    text: message,
    confirmButtonText: 'OK'
  });
}

getError(error: any): string {
  const firebaseErrorMessages: { [key: string]: string } = {
    "auth/wrong-password": "Falsches Passwort. Bitte versuchen Sie es erneut.",
    "auth/user-not-found": "Kein Konto mit dieser E-Mail-Adresse gefunden.",
    "auth/email-already-in-use": "Diese E-Mail-Adresse wird bereits verwendet.",
    "auth/weak-password": "Das Passwort ist zu schwach. Bitte wählen Sie ein stärkeres Passwort.",
    "auth/invalid-email": "Die E-Mail-Adresse ist ungültig.",
    "auth/network-request-failed": "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
    "permission-denied": "Sie haben keine Berechtigung, diese Aktion auszuführen.",
    "storage/object-not-found": "Die angeforderte Datei wurde nicht gefunden.",
    "storage/canceled": "Der Datei-Upload wurde abgebrochen.",
    "storage/unauthorized": "Sie sind nicht berechtigt, auf diese Datei zuzugreifen."
  };

  // Extrahiere Firebase-Fehlercode
  const errorCode: string = error?.code || "";

  // Prüfe, ob eine benutzerfreundliche Nachricht vorhanden ist
  if (firebaseErrorMessages[errorCode]) {
    return firebaseErrorMessages[errorCode];
  }

  // Wenn nicht gefunden, bereinige die Standard-Firebase-Nachricht
  let rawMessage = error?.message || "Ein unbekannter Fehler ist aufgetreten.";
  rawMessage = rawMessage.replace(/^Firebase: Error\s*\((.*)\)\.?/, "$1");

  return `Etwas ist schiefgelaufen: ${rawMessage}`;
}

 getNotificationIcon(type: string): string {
  switch (type) {
    case 'NEW_JOB_POSTED':
      return 'fa-solid fa-briefcase text-primary'; // Briefcase for job postings (professional, blue)
    case 'APPLICATION_RECEIVED':
      return 'fa-solid fa-paper-plane text-info'; // Paper plane for submitted applications (informative, light blue)
    case 'APPLICATION_PENDING':
      return 'fa-solid fa-hourglass-half text-warning'; // Hourglass for pending applications (waiting, yellow)
    case 'APPLICATION_REVIEWED':
      return 'fa-solid fa-eye text-info'; // Eye for reviewed applications (viewed, light blue)
    case 'APPLICATION_ACCEPTED':
      return 'fa-solid fa-check-circle text-success'; // Check circle for accepted applications (positive, green)
    case 'APPLICATION_REJECTED':
      return 'fa-solid fa-times-circle text-danger'; // Times circle for rejected applications (negative, red)
    case 'APPLICATION_STATUS_UPDATE':
      return 'fa-solid fa-sync-alt text-primary'; // Sync for generic status updates (neutral, blue)
    case 'APPLICATION_DELETED':
      return 'fa-solid fa-trash-can text-danger'; // Trash can for deleted applications (negative, red)
    case 'ACCOUNT_APPROVED':
      return 'fa-solid fa-user-shield text-success'; // User shield for approved accounts (secure, green)
    case 'ACCOUNT_REJECTED':
      return 'fa-solid fa-user-slash text-danger'; // User slash for rejected accounts (negative, red)
    case 'MESSAGE':
      return 'fa-solid fa-envelope-open text-secondary'; // Open envelope for messages (gray, indicating new mail)
    case 'SYSTEM':
      return 'fa-solid fa-gear text-dark'; // Gear for system updates (dark, technical)
    case 'NEW_ARTICLE':
      return 'fa-solid fa-newspaper text-warning'; // Newspaper for new articles (yellow, attention-grabbing)
    case 'PUBLIC_ANNOUNCEMENT':
      return 'fa-solid fa-bullhorn text-warning'; // Bullhorn for announcements (yellow, urgent)
    case 'NEW_USER_REGISTERED':
      return 'fa-solid fa-user-plus text-success'; // User plus for new registrations (green, positive)
    case 'COMMENT':
      return 'fa-solid fa-comment-dots text-info'; // Comment dots for comments (light blue, conversational)
    case 'REPLY':
      return 'fa-solid fa-reply-all text-secondary'; // Reply all for replies (gray, response-oriented)
    case 'PASSWORD_RESET':
      return 'fa-solid fa-key text-warning'; // Key for password resets (yellow, security-related)
    case 'LOGIN':
      return 'fa-solid fa-sign-in-alt text-primary'; // Sign-in for login events (blue, access-related)
    default:
      return 'fa-solid fa-bell text-muted'; // Bell as default (muted, neutral)
  }
}


  getPlatformIcon(platform: SocialMediaPlatform): string {
    switch (platform) {
      case SocialMediaPlatform.Twitter:
        return 'fab fa-twitter';
      case SocialMediaPlatform.Facebook:
        return 'bi bi-facebook';
      case SocialMediaPlatform.Instagram:
        return 'bi bi-instagram';
      case SocialMediaPlatform.LinkedIn:
        return 'bi bi-linkedin';
      case SocialMediaPlatform.YouTube:
        return 'fab fa-youtube';
      case SocialMediaPlatform.X:
        return "bi bi-twitter-x"
      default:
        return 'fas fa-globe';
    }
  }
}
